import { render, staticRenderFns } from "./CustomFileUpload.vue?vue&type=template&id=5323bf84&scoped=true"
import script from "./CustomFileUpload.vue?vue&type=script&lang=js"
export * from "./CustomFileUpload.vue?vue&type=script&lang=js"
import style0 from "./CustomFileUpload.vue?vue&type=style&index=0&id=5323bf84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323bf84",
  null
  
)

export default component.exports